<template>
  <main class="ws-page">
    <header class="ws-page-header">
      <h1 class="ws-page-header__title has-text-weight-bold is-size-2" v-text="$t('404 Страница не найдена')"></h1>
    </header>
    <p v-text="$t('Извините, страница которую вы искали, не найдена.')"></p>
    <p>
      <router-link to="/" v-text="$t('Перейти на главную страницу')"></router-link>
    </p>
  </main>
</template>

<script>
export default {
  name: 'WsPageNotFound'
}
</script>
